// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-modal {
  max-width: 600px;
}

.feedback-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  background-color: var(--color-bg-card);
  color: var(--color-text-light);
  resize: vertical;
  min-height: 150px;
}

.feedback-textarea:focus {
  outline: none;
  border-color: var(--wylie-purple);
  box-shadow: 0 0 0 0.2rem rgba(80, 7, 120, 0.25);
}

.feedback-textarea:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/FeedbackModal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sCAAsC;EACtC,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".feedback-modal {\n  max-width: 600px;\n}\n\n.feedback-textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  background-color: var(--color-bg-card);\n  color: var(--color-text-light);\n  resize: vertical;\n  min-height: 150px;\n}\n\n.feedback-textarea:focus {\n  outline: none;\n  border-color: var(--wylie-purple);\n  box-shadow: 0 0 0 0.2rem rgba(80, 7, 120, 0.25);\n}\n\n.feedback-textarea:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
